import styled, { css } from 'styled-components';

import variables from '../../../../styles/variables';
import Input from '../../../elements/Input/Input';

// GENERAL FORM STYLES
export const FormWrapper = styled.div`
  flex-basis: 30%;
  position: relative;
  align-items: flex-start;
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
`;

export const BladeSubtitle = styled.h3`
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 20px;
`;

export const Form = styled.div`
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  fieldset {
    width: 100%;
    float: left;
    margin-bottom: 1rem;
    border: none;
    &#phoneField {
      margin-bottom: 0;
    }
    &.half {
      width: 45%;
      @media screen and (max-width: 1024px) {
        width: 100%;
        clear: both;
      }
    }
    &.submit {
      margin: 1rem auto 2rem;
    }
    &.recaptcha {
      margin: 0.5rem auto 1rem;
      iframe {
        margin-bottom: 0;
      }
    }
    &.location {
      margin-bottom: 1rem;
    }
    label {
      float: left;
      font-size: 14px;
    }
  }
`;

export const InputField = styled(Input)<{status: string;}>`
  padding-left: 14px;
  height: 32px;
  width: 100%;
  margin: 0.5rem auto;
  background: rgba(216, 216, 216, 0.25);
  border: none;
  font-size: 14px;
  transition: all 400ms ease;
  ${({ status }) => status === 'errorField' ? errorFieldMixin : null}
  ${({ status }) => status === 'validField' ? validFieldMixin : null}
`;

export const ErrorMsg = styled.div`
  color: ${variables.colorRed};
  font-size: 12px;
  clear: both;
  &.recaptcha {
    margin-top: 0.5rem;
  }
`;

const errorFieldMixin = css`
  border: 1px solid ${variables.colorRed};
  transition: all 400ms ease;
`;

const validFieldMixin = css`
  border: 1px solid green;
  transition: all 400ms ease;
`;
